import { fetchRecipesById } from "../../api/recipesListApi";
import * as Endpoints from "../../entities/Endpoints";

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchRecipeByIdThunk = createAsyncThunk(
  Endpoints.GET_RECIPE_BY_ID,
  async ({ coachId, recipeId }, { rejectWithValue }) => {
    try {
      const data = await fetchRecipesById({ coachId, recipeId });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const recipesByIdSlice = createSlice({
  name: "getRecipesById",
  initialState: {
    recipeDetails: null,
    isloadingById: false,
    error: null,
    successMessage: null,
    updateSuccessMessage: "",
    updateFailedMessage: "",
  },
  reducers: {
    clearUpdateMessage: (state) => {
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRecipeByIdThunk.pending, (state) => {
        state.isloadingById = true;
        state.error = null;
        state.updateSuccessMessage = "";
        state.updateFailedMessage = "";
      })
      .addCase(fetchRecipeByIdThunk.fulfilled, (state, action) => {
        state.isloadingById = false;
        state.recipeDetails = action.payload;
      })
      .addCase(fetchRecipeByIdThunk.rejected, (state, action) => {
        state.isloadingById = false;
        state.error = action.payload;
        state.updateFailedMessage = action.payload;
      });
  },
});
export const { clearUpdateMessage } = recipesByIdSlice.actions;
export const recipesByIdReducer = recipesByIdSlice.reducer;
